/**
 * violex-keychain-upsell.js — geteilte Keychain-Upsell-Logik.
 *
 * Genutzt von violex-cart.js (Warenkorb-Seite) UND violex-cart-drawer.js
 * (Slide-in-Panel), damit "Keychain-Varianten laden", "Swatches rendern" und
 * "Keychain per Klick hinzufügen" nicht zweimal gepflegt werden - dieselbe
 * Art doppelter Wahrheit, vor der Doku/tiefenanalyse-bestellprozess-elite-
 * storage.md §2.1 warnt.
 *
 * Reine Helfer-Funktionen, keine eigene DOM-Bindung - der Aufrufer entscheidet
 * WO/WANN gerendert wird.
 */
(function () {
  'use strict';

  const COLOUR_CLASS = {
    'Black-Violet': 'vx-swatch--black-violet',
    'Black-Green': 'vx-swatch--black-green',
    'White-Violet': 'vx-swatch--white-violet',
    'Grey-Black': 'vx-swatch--grey-black',
    'Violet-Black': 'vx-swatch--violet-black',
  };

  /** @returns {Promise<Array<{id:number, title:string, price:number, available:boolean}>>} */
  async function fetchVariants(handle) {
    try {
      const res = await fetch('/products/' + handle + '.json');
      if (!res.ok) return [];
      const data = await res.json();
      return (data.product?.variants ?? []).map((v) => ({
        id: v.id,
        title: v.title,
        price: parseFloat(v.price),
        available: v.available,
      }));
    } catch (_e) {
      return [];
    }
  }

  /** Bevorzugt eine verfügbare Variante - null, solange noch nichts geladen ist. */
  function firstAvailablePrice(variants) {
    const variant = variants.find((v) => v.available) || variants[0];
    return variant ? variant.price : null;
  }

  /**
   * Rendert Farb-Swatches in `container` und ruft `onPick(variantId, swatchEl)`
   * bei Klick auf eine verfügbare Farbe. Ohne verfügbare Varianten: Link auf
   * die Produktseite als Fallback statt eines leeren Elements.
   */
  function renderSwatches(container, variants, fallbackUrl, onPick) {
    const colours = variants.filter((v) => v.available);

    if (colours.length === 0) {
      container.innerHTML = `<a class="vx-swatches__fallback" href="${fallbackUrl}">Keychain ansehen →</a>`;
      return;
    }

    container.innerHTML = colours
      .map(
        (v) => `<button
          type="button"
          class="vx-swatch ${COLOUR_CLASS[v.title] || ''}"
          data-variant-id="${v.id}"
          data-colour="${escAttr(v.title)}"
          title="${escAttr(v.title)}"
          aria-label="${escAttr(v.title)}"
        ></button>`,
      )
      .join('');

    container.querySelectorAll('.vx-swatch').forEach((btn) => {
      btn.addEventListener('click', () => onPick(btn.dataset.variantId, btn));
    });
  }

  /** Wirft bei Fehler (res.ok geprüft, JSON-sicher geparst) - Aufrufer fängt ab. */
  async function addVariant(variantId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });
    const raw = await res.text();
    let data = null;
    try {
      data = JSON.parse(raw);
    } catch (_e) {
      data = null;
    }
    if (!res.ok || !data) {
      throw new Error((data && (data.description || data.message)) || 'Hinzufügen fehlgeschlagen.');
    }
    return data;
  }

  function escAttr(str) {
    return String(str || '').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  window.ViolexKeychainUpsell = { fetchVariants, firstAvailablePrice, renderSwatches, addVariant };
})();
